module.exports = __webpack_public_path__ + "static/img/t36.27be6cd3.png";